import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import SidebarDropdown from './api/SidebarDropdown';
import Sidebar from './api/Sidebar';
import Category from './api/Category';
import ObjectType from './api/ObjectType';
import Footer from './shared/Footer';

const Api = ({ categories, selectedCategory, response, history }) => {
	return (
		<div className="page">
			{/* Sidebar */}
			<Sidebar categories={categories} />

			{/* Content */}
			<main className="content with-sidebar" id="content">
				{/*Sidebar Dropdown */}
				<div className="responsive-small">
					<SidebarDropdown categories={categories} />
				</div>
				<div className="section">

					<h1>API Reference</h1>
					<p>This section is a complete reference guide for the Dynamic Signal APIs.</p>
					{/* Category */}
					{selectedCategory &&
						<div className="categories" id="categories">
							<div className="category-list">
								<Category category={selectedCategory} />
							</div>
						</div>
					}

					{/* Response Object */}
					{response &&
						<ObjectType response={response} history={history} />
					}
				</div>
				<Footer />
			</main>

		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const { match } = ownProps;
	const { category, response } = match.params;

	return {
		categories: state.api.categories,
		selectedCategory: state.api.categories.filter(c => c.name === category)[0],
		response: state.api.responses[response]
	};
};

Api.propTypes = {
	categories: PropTypes.array.isRequired,
	selectedCategory: PropTypes.object,
	response: PropTypes.object,
	history: PropTypes.object
};

export default withRouter(connect(mapStateToProps)(Api));


// WEBPACK FOOTER //
// ./src/components/Api.js